module.exports = __webpack_public_path__ + "img/fk4151_center_001.0c6d909a.png";